import React from 'react';
import { Divider, Form, Input, Select, Space } from 'antd';
import { MinusCircleOutlined } from '@ant-design/icons';
import { Delete03Icon } from '../../../components/icons';

const { Option } = Select;

const endpointCategories = [
  { label: 'Biomarker', value: 'Biomarker' },
  { label: 'Safety', value: 'Safety' },
  { label: 'Adverse Effects', value: 'Adverse Effects' },
  { label: 'Survival', value: 'Survival' },
  { label: 'Quality of Life', value: 'Quality of Life' },
  { label: 'Response', value: 'Response' },
  { label: 'Disease Progression', value: 'Disease Progression' },
  { label: 'Pharmacokinetics', value: 'Pharmacokinetics' },
  { label: 'Pharmacodynamics', value: 'Pharmacodynamics' },
  { label: 'Efficacy', value: 'Efficacy' },
  { label: 'Other', value: 'Other' },
];

const EndpointFormItem = ({ name, restField, onRemove }) => {
  return (
    <Space
      style={{ display: 'flex', marginBottom: 8, alignItems: 'start', justifyContent: 'space-between' }}
      align="baseline"
      split={<Divider type="vertical" className="h-16" />}
    >
      <Form.Item
        {...restField}
        name={[name, 'name']}
        label="Endpoint Name"
        className="w-48"
        rules={[{ required: true, message: 'Missing endpoint name' }]}
      >
        <Input placeholder="e.g., Overall Survival, Progression-Free Survival" />
      </Form.Item>
      <Form.Item
        {...restField}
        name={[name, 'category']}
        label="Endpoint Category"
        className="w-48"
        rules={[{ required: true, message: 'Missing endpoint category' }]}
      >
        <Select placeholder="Select category">
          {endpointCategories.map((category) => (
            <Option key={category.value} value={category.value}>
              {category.label}
            </Option>
          ))}
        </Select>
      </Form.Item>
      <Delete03Icon onClick={onRemove} className="cursor-pointer h-4 w-4 text-red-500" />
    </Space>
  );
};

export default EndpointFormItem;
